import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { CONTACT_US_ROUTE } from 'data/global';

import './FetchFailedPage.styles.scss';

type FetchFailedPageProps = {
  className?: string;
};

const FetchFailedPage: React.FC<FetchFailedPageProps> = (props) => {
  const { className } = props;

  const classes = classNames('fetch-failed-page', className);

  return (
    <div className={classes}>
      <h1>Something went wrong</h1>
      <p>
        Please <a href="/">go back</a>, or{' '}
        <Link to={CONTACT_US_ROUTE}>contact us.</Link>
      </p>
    </div>
  );
};

export default FetchFailedPage;
